import { padTwo } from '../helpers/padTwo';
// formatDateYmd(new Date('2025-12-17T14:30:00')) -> "2025-12-17"
export const formatDateYmd = (date) => `${date.getFullYear()}-${padTwo(date.getMonth() + 1)}-${padTwo(date.getDate())}`;
